// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ce86f-portal{box-shadow:none;gap:8px;display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./app/pages/MatchPage/Microbetting/LolEpicMonsterIndexInput/style.scss"],"names":[],"mappings":"AAEA,cACE,eAAA,CACA,OAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":["@import \"theme\";\n\n.portal {\n  box-shadow: none;\n  gap: 8px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portal": "ce86f-portal"
};
export default ___CSS_LOADER_EXPORT___;
